module.exports = __webpack_public_path__ + "static/media/contactActive.2fee53dd.svg";